<template>
    <div class="d-flex align-center">
        <v-btn icon
        :href="url"
        >
            <v-icon color="info">
                mdi-information
            </v-icon>
        </v-btn>
        <v-card-title class="text-h5 pl-0">
            {{ title }}
        </v-card-title>
    </div>
</template>

<script>
export default {
    props: [ 'url', 'title' ]
}
</script>
